import {
  colorVariants,
  extendVariants,
  Chip as NextUIChip,
} from "@heroui/react";
import clsx from "clsx";

const ExtendedChip = extendVariants(NextUIChip, {
  compoundVariants: [
    // solid / color
    {
      class: [colorVariants.solid.default],
      color: "default",
      variant: "solid",
    },
    {
      class: [colorVariants.solid.primary],
      color: "primary",
      variant: "solid",
    },
    {
      class: [colorVariants.solid.secondary],
      color: "secondary",
      variant: "solid",
    },
    {
      class: [colorVariants.solid.success],
      color: "success",
      variant: "solid",
    },
    {
      class: [colorVariants.solid.warning],
      color: "warning",
      variant: "solid",
    },
    {
      class: [colorVariants.solid.danger],
      color: "danger",
      variant: "solid",
    },
    // shadow / color
    {
      class: [colorVariants.shadow.default],
      color: "default",
      variant: "shadow",
    },
    {
      class: [colorVariants.shadow.primary],
      color: "primary",
      variant: "shadow",
    },
    {
      class: [colorVariants.shadow.secondary],
      color: "secondary",
      variant: "shadow",
    },
    {
      class: [colorVariants.shadow.success],
      color: "success",
      variant: "shadow",
    },
    {
      class: [colorVariants.shadow.warning],
      color: "warning",
      variant: "shadow",
    },
    {
      class: [colorVariants.shadow.danger],
      color: "danger",
      variant: "shadow",
    },
    // bordered / color
    {
      class: ["border-white", "text-white", "bg-transparent"],
      color: "white",
      variant: "bordered",
    },
    {
      class: ["border-black", "text-base-900", "bg-transparent"],
      color: "black",
      variant: "bordered",
    },
    {
      class: ["border-gray-500", "text-gray-900", "bg-transparent"],
      color: "gray",
      variant: "bordered",
    },
    {
      class: [colorVariants.bordered.default, "bg-transparent"],
      color: "default",
      variant: "bordered",
    },
    {
      class: [
        colorVariants.bordered.primary,
        "border-primary",
        "text-primary",
        "bg-transparent",
      ],
      color: "primary",
      variant: "bordered",
    },
    {
      class: [
        colorVariants.bordered.secondary,
        "border-secondary",
        "text-secondary",
        "bg-transparent",
      ],
      color: "secondary",
      variant: "bordered",
    },
    {
      class: ["border-accent-dark", "text-accent-dark", "bg-transparent"],
      color: "accent",
      variant: "bordered",
    },
    {
      class: [
        colorVariants.bordered.success,
        "border-success",
        "text-success",
        "bg-transparent",
      ],
      color: "success",
      variant: "bordered",
    },
    {
      class: [
        colorVariants.bordered.warning,
        "border-warning-dark",
        "text-warning-dark",
        "bg-transparent",
      ],
      color: "warning",
      variant: "bordered",
    },
    {
      class: [
        colorVariants.bordered.danger,
        "border-danger",
        "text-danger",
        "bg-transparent",
      ],
      color: "danger",
      variant: "bordered",
    },
    // flat / color
    {
      class: [colorVariants.flat.default],
      color: "default",
      variant: "flat",
    },
    {
      class: [],
      color: "white",
      variant: "flat",
    },
    {
      class: [],
      color: "black",
      variant: "flat",
    },
    {
      class: [],
      color: "gray",
      variant: "flat",
    },
    {
      class: [colorVariants.flat.primary, "bg-blue-100", "text-primary-dark"],
      color: "primary",
      variant: "flat",
    },
    {
      class: [
        colorVariants.flat.secondary,
        "bg-secondary-light",
        "text-yellow-900",
      ],
      color: "secondary",
      variant: "flat",
    },
    {
      class: ["bg-accent-light", "text-purple-800"],
      color: "accent",
      variant: "flat",
    },
    {
      class: ["bg-success-light", "text-green-700"],
      color: "success",
      variant: "flat",
    },
    {
      class: [
        colorVariants.flat.warning,
        "bg-warning-light",
        "text-orange-800",
      ],
      color: "warning",
      variant: "flat",
    },
    {
      class: [colorVariants.flat.danger, "bg-danger-light", "text-red-900"],
      color: "danger",
      variant: "flat",
    },
    // faded / color
    {
      class: [colorVariants.faded.default, "border-gray-500"],
      color: "default",
      variant: "faded",
    },
    {
      class: [
        colorVariants.faded.default,
        "bg-gray-900",
        "text-white",
        "border-gray-500",
      ],
      color: "white",
      variant: "faded",
    },
    {
      class: ["bg-gray-50", "text-base-900", "border-gray-500"],
      color: "black",
      variant: "faded",
    },
    {
      class: ["bg-gray-50", "text-gray-600", "border-gray-500"],
      color: "gray",
      variant: "faded",
    },
    {
      class: [
        colorVariants.faded.primary,
        "bg-gray-50",
        "text-primary",
        "border-gray-500",
      ],
      color: "primary",
      variant: "faded",
    },
    {
      class: [
        colorVariants.faded.secondary,
        "bg-gray-900",
        "text-secondary-dark",
        "border-gray-500",
      ],
      color: "secondary",
      variant: "faded",
    },
    {
      class: ["bg-gray-50", "text-accent-dark", "border-gray-500"],
      color: "accent",
      variant: "faded",
    },
    {
      class: [
        colorVariants.faded.success,
        "bg-gray-50",
        "text-success",
        "border-gray-500",
      ],
      color: "success",
      variant: "faded",
    },
    {
      class: [
        colorVariants.faded.warning,
        "bg-gray-50",
        "text-warning-dark",
        "border-gray-500",
      ],
      color: "warning",
      variant: "faded",
    },
    {
      class: [
        colorVariants.faded.danger,
        "bg-gray-50",
        "text-danger-dark",
        "border-gray-500",
      ],
      color: "danger",
      variant: "faded",
    },
    // light / color
    {
      class: [colorVariants.light.default],
      color: "default",
      variant: "light",
    },
    {
      class: [colorVariants.light.primary],
      color: "primary",
      variant: "light",
    },
    {
      class: [colorVariants.light.secondary],
      color: "secondary",
      variant: "light",
    },
    {
      class: [colorVariants.light.success],
      color: "success",
      variant: "light",
    },
    {
      class: [colorVariants.light.warning],
      color: "warning",
      variant: "light",
    },
    {
      class: [colorVariants.light.danger],
      color: "danger",
      variant: "light",
    },
    // dot / color
    {
      class: ["bg-transparent"],
      color: "default",
      variant: "dot",
    },
    {
      class: ["text-white", "border-white", "bg-transparent"],
      color: "white",
      variant: "dot",
    },
    {
      class: ["text-gray-900", "bg-transparent"],
      color: "black",
      variant: "dot",
    },
    {
      class: ["text-gray-900", "bg-transparent"],
      color: "gray",
      variant: "dot",
    },
    {
      class: ["text-gray-900", "bg-transparent"],
      color: "primary",
      variant: "dot",
    },
    {
      class: ["text-white", "border-white", "bg-transparent"],
      color: "secondary",
      variant: "dot",
    },
    {
      class: ["text-base-900", "bg-transparent"],
      color: "accent",
      variant: "dot",
    },
    {
      class: ["bg-transparent"],
      color: "success",
      variant: "dot",
    },
    {
      class: ["bg-transparent"],
      color: "warning",
      variant: "dot",
    },
    {
      class: ["bg-transparent"],
      color: "danger",
      variant: "dot",
    },
    // isOneChar / size
    {
      class: ["w-5 h-5 min-w-5 min-h-5"],
      hasEndContent: false,
      hasStartContent: false,
      isOneChar: true,
      size: "sm",
    },
    {
      class: ["w-6 h-6 min-w-6 min-h-6"],
      hasEndContent: false,
      hasStartContent: false,
      isOneChar: true,
      size: "md",
    },
    {
      class: ["w-7 h-7 min-w-7 min-h-7"],
      hasEndContent: false,
      hasStartContent: false,
      isOneChar: true,
      size: "lg",
    },
    // isOneChar / isCloseable
    {
      class: ["px-0 justify-center", "px-0 flex-none"],
      hasEndContent: false,
      hasStartContent: false,
      isCloseable: false,
      isOneChar: true,
    },
    {
      class: ["w-auto"],
      hasEndContent: false,
      hasStartContent: false,
      isCloseable: true,
      isOneChar: true,
    },
    // isOneChar / dot
    {
      class: ["w-auto h-7 px-1 items-center", "px-2"],
      isOneChar: true,
      variant: "dot",
    },
    // hasStartContent / size
    {
      class: ["pl-0.5"],
      hasStartContent: true,
      size: "sm",
    },
    {
      class: ["pl-1"],
      hasStartContent: true,
      size: ["md", "lg"],
    },
    // hasEndContent / size
    {
      class: ["pr-0.5"],
      hasEndContent: true,
      size: "sm",
    },
    {
      class: ["pr-1"],
      hasEndContent: true,
      size: ["md", "lg"],
    },
  ],
  defaultVariants: {
    color: "default",
    isDisabled: false,
    radius: "full",
    size: "md",
    variant: "solid",
  },
  slots: {
    avatar: ["flex-shrink-0", "h-4"],
    base: [
      "relative",
      "max-w-fit",
      "min-w-min",
      "inline-flex",
      "items-center",
      "justify-between",
      "box-border",
      "whitespace-nowrap",
    ],
    content: "flex-1 text-gray-900 font-normal",
    dot: ["w-2", "h-2", "ml-1", "rounded-full"],
  },
  variants: {
    color: {
      accent: {
        base: ["bg-accent-dark text-white"],
        dot: ["bg-accent-dark"],
      },
      black: {
        base: ["bg-black text-white"],
        dot: ["bg-black"],
      },
      danger: {
        dot: ["bg-danger"],
      },
      default: {
        dot: ["bg-default-400"],
      },
      gray: {
        base: ["bg-gray-400"],
        dot: ["bg-gray-500"],
      },
      primary: {
        dot: ["bg-primary"],
      },
      secondary: {
        dot: ["bg-secondary"],
      },
      success: {
        dot: ["bg-success"],
      },
      warning: {
        dot: ["bg-warning"],
      },
      white: {
        base: ["bg-white"],
        dot: ["bg-white"],
      },
    },
    hasEndContent: {
      true: {},
    },
    hasStartContent: {
      true: {},
    },
    isCloseable: {
      false: {},
      true: {},
    },
    isDisabled: {
      true: { base: ["opacity-disabled", "pointer-events-none"] },
    },
    isOneChar: {
      false: {},
      true: {},
    },
    radius: {
      full: {
        base: ["rounded-full"],
      },
      lg: {
        base: ["rounded-large"],
      },
      md: {
        base: ["rounded-medium"],
      },
      none: {
        base: ["rounded-none"],
      },
      sm: {
        base: ["rounded-small"],
      },
    },
    size: {
      lg: {
        base: ["px-3", "py-2", "h-9"],
        content: ["px-2 text-small"],
      },
      md: {
        base: ["px-3", "py-1.5", "h-8"],
        content: ["px-2 text-small"],
      },
      sm: {
        base: ["px-2", "py-1", "h-7"],
        content: ["px-1 text-body-sm"],
      },
    },
    variant: {
      bordered: {
        base: ["border-medium"],
      },
      dot: {
        base: [
          "border-medium",
          "border-default",
          "text-foreground",
          "border-gray-500",
        ],
        content: ["!pr-0"],
      },
      faded: {
        base: ["border-medium"],
      },
      flat: {},
      light: {
        base: ["bg-transparent"],
      },
      shadow: {},
      solid: {
        base: ["text-gray-900"],
      },
    },
  },
});

type ExtendedChipProps = React.ComponentProps<typeof ExtendedChip>;

type Variant = ExtendedChipProps["variant"];
type Color = ExtendedChipProps["color"];

export type ChipProps = Omit<ExtendedChipProps, "variant" | "color" | "id"> & {
  color?: Color;
  id: string;
  variant?: Variant;
  ref?: React.Ref<HTMLDivElement>;
};

export function Chip({ ref, ...props }: ChipProps) {
  return (
    <ExtendedChip
      {...props}
      ref={ref}
      classNames={{
        closeButton: clsx("opacity-100 ring-transparent", {
          "focus:ring-offset-primary": props.color !== "primary",
          "focus:ring-offset-white": props.color === "primary",
        }),
      }}
      data-testid={`chip-${props.id}`}
    />
  );
}

Chip.displayName = "RecareUI.Chip";
